<template>
  <div ref="modalContainer">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "ModalContainer",
  mounted() {
    // this will render the modal in the correct place
    document.getElementById('page-modals').appendChild(this.$refs.modalContainer);
  },
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";
</style>
